module.exports = __webpack_public_path__ + "804427574c91219e33064dcfc650ee49.jpg";